import styled from 'styled-components/macro';
import { desktopHover, pxtorem } from '~/utils/tools';
import arrow from '~/styles/img/product-testimonial-arrow.svg';
import { Wrapper } from '../../../styles/Wrapper.styled';

export const StyledTestimonials = styled.div`
  --color: var(--white);
  --swiper-theme-color: var(--color);
  position: relative; 
  h4 {
    text-align: center;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.33;
    color: var(--color);
    margin: 0 0 1em;
  }

  

  blockquote {
    --lineHeight: 1;
    color: var(--color);
    text-align: center;
    margin: 0 60px;
    font-size: ${pxtorem(28)};
    line-height: var(--lineHeight);

    & .quote {
      min-height: calc(var(--lineHeight) * 3em);
    }

    & p {
      margin: 0;
    }
  }

  cite {
    display: block;
    font-style: normal;
    margin: 20px 0 0;

    & span {
      display: block;
      margin: 4px 0 0;
      font-size: 12px;
      font-weight: 500;
      line-height: 1.33;
    }
  }

  figure {
    --size: 45px;
    margin: 0 auto;
    border-radius: 50%;
    overflow: hidden;
    width: var(--size);
    height: var(--size);

    & img {
      display: block;
      object-fit: cover;
      width: 100%;
    }
  }

  .back-button, .next-button {
    display: none;
    top: 32.5%;
    position: absolute;
    background: none;
    width: 40px;
    border: none;
    cursor: pointer;

    @media (min-width: 1118px) {
      display: block;
    }
  }

  .back-button {
    left: 5%;
  }

  .next-button {
    right: 5%;
  }

  & .swiper-button-prev,
  & .swiper-button-next {
    mask: url(${arrow}) center no-repeat;
   
    mask-size: contain;
    background: var(--white);
    width: 39px;
    transition: background 0.25s;

    ${desktopHover(`background: var(--lime);`)}

    &:after {
      display: none;
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  & .swiper-button-prev {
    transform: scale(-1, 1); 
  }

  .mobile-arrows {
    margin-top: ${pxtorem(48)};
    display: flex;
    justify-content: center;
    gap: 24px;

    button {
      cursor: pointer;
      &:first-child svg {
        position: relative;
        transform: scale(-1);
      }

      border: none;
      background: none;

      svg {
        fill: var(--white);
        width: auto;
        height: 24px;
        opacity: 0.1;
        transition: opacity 0.3s var(--cubic-ease);
      } 

      &:hover, &:focus {
        svg {
          opacity: 1;
        }
      }
    }


    @media (min-width: 1118px) {
      display: none;
    }
  }

  @media (min-width: 768px) {
    h4 {
      font-size: ${pxtorem(16)};
    }

    blockquote {
      font-size: ${pxtorem(40)};
      line-height: var(--lineHeight);
    }

    cite {
      & span {
        font-size: ${pxtorem(16)};
        font-weight: 400;
      }
    }

    figure {
      --size: 66px;
    }
  }
`;
